import { Component, AfterViewInit, ViewChild } from '@angular/core';
import {
    ScriptLoaderService, ClassService
} from './../../../../../_services';
import {
    Investor
} from './../../../../../_models';
import { InvestorTableComponent } from '../investor-table';

@Component({
    selector: 'app-investor-list',
    templateUrl: './investor-list.component.html',
})

export class InvestorListComponent implements AfterViewInit {
    static initialClass: string =
    'm-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    private investorTable: InvestorTableComponent;
    @ViewChild(InvestorTableComponent) set content(content: InvestorTableComponent) {
        this.investorTable = content;
        this.investorTable.getData().subscribe(investors => {
            this.allInvestorsCount = investors.length;
        });
    }
    allInvestorsCount: number;
    totalInvestment: number;
    name: string;
    email: string;
    sort: any = {};
    searchString: string;
    areaInPoolFrom: number;
    areaInPoolTo: number;
    mottoValueInPoolFrom: number;
    mottoValueInPoolTo: number;
    currentUser: any = JSON.parse(localStorage.getItem('currentUser'));

    tableMessages = [
        {
            // Message to show when array is presented
            // but contains no values
            emptyMessage: 'No existen registros',

            // Footer total message
            totalMessage: ''
        }];
    listContainer = {
        header: {
            icon: 'fa fa-users',
            text: 'PROPIETARIOS'
        },
        newEntry: {
            link: '/investors/new',
            text: 'Registrar'
        }
    }
    constructor(
        private _script: ScriptLoaderService,
        private _classService: ClassService,
        private data: Investor
    ) { }

    ngAfterViewInit() {
        this._script.loadScripts('app-investor-list',
            ['assets/app/js/investor.js']);
        this._classService.setClass(document.body, InvestorListComponent.initialClass);
    }

    buildSearchString(name, email) {
        let result = ``;
        let theName = (name != this.name) ? name : this.name;
        let theEmail = (email != this.email) ? email : this.email;
        if (theName) {
            result += `name=${theName}`;
        }
        if (theEmail) {
            result += `&email=${theEmail}`;
        }
        if (this.sort.dir && this.sort.column) {
            result += `&sortDir=${this.sort.dir}&sortBy=${this.sort.column}`;
        }
        if (this.areaInPoolFrom) {
            result += `&areaInPoolFrom=${this.areaInPoolFrom}`;
        }
        if (this.areaInPoolTo) {
            result += `&areaInPoolTo=${this.areaInPoolTo}`;
        }
        if (this.mottoValueInPoolFrom) {
            result += `&mottoValueInPoolFrom=${this.mottoValueInPoolFrom}`;
        }
        if (this.mottoValueInPoolTo) {
            result += `&mottoValueInPoolTo=${this.mottoValueInPoolTo}`;
        }
        this.searchString = result;
    }
    search() {
        if (this.investorTable)
            this.investorTable.getData(this.searchString).subscribe(investors => { });
    }
    clear() {
        this.name = '';
        this.email = '';
        this.sort = {};
        this.areaInPoolFrom = null;
        this.areaInPoolTo = null;
        this.mottoValueInPoolFrom = null;
        this.mottoValueInPoolTo = null;
        if (this.investorTable)
            this.investorTable.getData().subscribe(investors => { });
    }
    onSort(data) {
        this.sort = data;
        this.buildSearchString(this.name, this.email);
        this.search();
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-list/investor-list.component.ts